module.exports = __webpack_public_path__ + "img/how9.59405331.png";